import { forwardRef, Icon, IconProps } from '@chakra-ui/react';

const BuildCache = forwardRef<IconProps, 'svg'>((props, ref) => (
  <Icon ref={ref} viewBox="0 0 24 24" {...props}>
    <path d="M17.5 10.5V15.5H15.5V10.5H17.5Z" fill="currentColor" />
    <path d="M11.5 15.5V9H9.5V15.5H11.5Z" fill="currentColor" />
    <path d="M8.5 10.5V15.5H6.5V10.5H8.5Z" fill="currentColor" />
    <path d="M14.5 15.5V12.5H12.5V15.5H14.5Z" fill="currentColor" />
    <path
      clipRule="evenodd"
      d="M5.79687 5.22032C9.5509 4.92656 14.4491 4.92656 18.2032 5.22032C19.5342 5.32447 20.5956 6.31592 20.8455 7.59604C21.467 10.7795 21.8439 13.16 21.9607 15.812C22.0297 17.3778 20.838 18.6941 19.2818 18.7968C15.1741 19.0677 8.82589 19.0677 4.71815 18.7968C3.16202 18.6941 1.97032 17.3778 2.03929 15.812C2.15609 13.16 2.53305 10.7795 3.15453 7.59604C3.40443 6.31592 4.46585 5.32447 5.79687 5.22032ZM18.0471 7.21422C14.397 6.92859 9.60306 6.92859 5.95289 7.21422C5.54812 7.2459 5.20117 7.55053 5.11747 7.97925C4.5024 11.1299 4.14762 13.3963 4.03735 15.9C4.01658 16.3715 4.37106 16.7695 4.8498 16.8011C8.86987 17.0663 15.1301 17.0663 19.1502 16.8011C19.6289 16.7695 19.9834 16.3715 19.9627 15.9C19.8524 13.3963 19.4976 11.1299 18.8826 7.97925C18.7989 7.55053 18.4519 7.2459 18.0471 7.21422Z"
      fill="currentColor"
      fillRule="evenodd"
    />
  </Icon>
));

export default BuildCache;
